import { Close } from "@radix-ui/react-dialog";
import { FiX } from "react-icons/fi";

export const ModalPresentational = (props: { children: React.ReactNode }) => {
  return (
    <div className="grid max-h-screen w-full max-w-[90vw] grid-rows-[auto,1fr] rounded-md bg-white shadow-lg md:max-w-md">
      <div className="flex justify-end px-8 py-2">
        <Close className="-mr-5 flex h-[44px] w-[44px] items-center justify-center">
          <FiX size={22} />
        </Close>
      </div>
      <div className="h-full w-full overflow-y-auto pb-8">{props.children}</div>
    </div>
  );
};
